import img_0 from "../../animations/grad/images/img_0.png"
import img_1 from "../../animations/grad/images/img_1.png"
import img_2 from "../../animations/grad/images/img_2.png"
import img_3 from "../../animations/grad/images/img_3.png"
import img_4 from "../../animations/grad/images/img_4.png"
import img_5 from "../../animations/grad/images/img_5.png"
import img_6 from "../../animations/grad/images/img_6.png"

const animation1152c = {
  v: "5.6.8",
  fr: 30,
  ip: 0,
  op: 153,
  w: 1152,
  h: 705,
  nm: "grad lottie 1152px  UPDATE 21.7. (brod bez svega)",
  ddd: 0,
  assets: [
    { id: "image_0", w: 179, h: 215, u: "", p: img_0, e: 0 },
    { id: "image_1", w: 56, h: 90, u: "", p: img_1, e: 0 },
    { id: "image_2", w: 869, h: 214, u: "", p: img_2, e: 0 },
    { id: "image_3", w: 546, h: 109, u: "", p: img_3, e: 0 },
    { id: "image_4", w: 1154, h: 325, u: "", p: img_4, e: 0 },
    { id: "image_5", w: 1154, h: 247, u: "", p: img_5, e: 0 },
    { id: "image_6", w: 76, h: 91, u: "", p: img_6, e: 0 },
  ],
  layers: [
    {
      ddd: 0,
      ind: 2,
      ty: 2,
      nm: "veliki brod",
      refId: "image_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 0,
              s: [-8.302],
            },
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 51,
              s: [7.698],
            },
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 88,
              s: [-5.302],
            },
            {
              i: { x: [0.54], y: [1] },
              o: { x: [0.167], y: [0.167] },
              t: 96,
              s: [-6.041],
            },
            { t: 152, s: [-10.041] },
          ],
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.62, y: 1 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [1269.829, 486.253, 0],
              to: [-80, 0, 0],
              ti: [80, 0, 0],
            },
            { t: 152, s: [789.829, 486.253, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [92.754, 204.322, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      ip: 0,
      op: 153,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 2,
      nm: "3-Test-lovre-web-(l-minimalno)_0001_mali-brod.png",
      cl: "png",
      parent: 5,
      refId: "image_1",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.4, y: 1 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [355.5, 52, 0],
              to: [-11.5, -4.167, 0],
              ti: [11.5, 4.167, 0],
            },
            { t: 123, s: [286.5, 27, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [28, 45, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      ip: 0,
      op: 153,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 2,
      nm: "3-Test-lovre-web-(l-minimalno)_0002_veca-linija.png",
      cl: "png",
      refId: "image_2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [486, 500.5, 0], ix: 2 },
        a: { a: 0, k: [434.5, 107, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 0,
              s: [120, 120, 100],
            },
            { t: 153, s: [100, 100, 100] },
          ],
          ix: 6,
        },
      },
      ao: 0,
      ip: 0,
      op: 153,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 2,
      nm: "3-Test-lovre-web-(l-minimalno)_0003_manja-linija.png",
      cl: "png",
      refId: "image_3",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [914, 492.5, 0], ix: 2 },
        a: { a: 0, k: [273, 54.5, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
              t: 0,
              s: [87, 87, 100],
            },
            { t: 153, s: [100, 100, 100] },
          ],
          ix: 6,
        },
      },
      ao: 0,
      ip: 0,
      op: 153,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 8,
      ty: 2,
      nm: "3-Test-lovre-web-(l-minimalno)_0004_Zgrade.png",
      cl: "png",
      refId: "image_4",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [576, 339.5, 0], ix: 2 },
        a: { a: 0, k: [577, 162.5, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.16, 0.16, 0.16], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.146] },
              t: 0,
              s: [113, 113, 100],
            },
            { t: 152, s: [100, 100, 100] },
          ],
          ix: 6,
        },
      },
      ao: 0,
      ip: 0,
      op: 153,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 11,
      ty: 2,
      nm: "3-Test-lovre-web-(l-minimalno)_0005_brdo.png",
      cl: "png",
      refId: "image_5",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.09, y: 1 },
              o: { x: 0.167, y: 0.167 },
              t: 0,
              s: [576, 346.5, 0],
              to: [0, -8.5, 0],
              ti: [0, 8.5, 0],
            },
            { t: 133, s: [576, 295.5, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [577, 123.5, 0], ix: 1 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.39, 0.39, 0.39], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.165] },
              t: 0,
              s: [100, 100, 100],
            },
            { t: 133, s: [102, 102, 100] },
          ],
          ix: 6,
        },
      },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "s",
          pt: {
            a: 0,
            k: {
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              v: [
                [107.929, 15.44],
                [93, 15.44],
                [94.461, 30.149],
                [107.929, 36.331],
              ],
              c: true,
            },
            ix: 1,
          },
          o: { a: 0, k: 100, ix: 3 },
          x: { a: 0, k: 0, ix: 4 },
          nm: "Mask 1",
        },
      ],
      ip: 0,
      op: 153,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 12,
      ty: 2,
      nm: "290 tovar 3.png",
      cl: "png",
      refId: "image_6",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.05, y: 1 },
              o: { x: 0.167, y: 0.167 },
              t: 77,
              s: [1084, 292.5, 0],
              to: [0, -23.833, 0],
              ti: [0, 23.833, 0],
            },
            { t: 106, s: [1084, 149.5, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [38, 45.5, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      ip: 0,
      op: 153,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
}

export default animation1152c
